"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.unionListToFirmwareUpdateDeviceId = exports.unionToFirmwareUpdateDeviceId = exports.FirmwareUpdateDeviceId = void 0;
const device_id_table_js_1 = require("../../solarxr-protocol/datatypes/device-id-table.js");
const serial_device_port_js_1 = require("../../solarxr-protocol/rpc/serial-device-port.js");
var FirmwareUpdateDeviceId;
(function (FirmwareUpdateDeviceId) {
    FirmwareUpdateDeviceId[FirmwareUpdateDeviceId["NONE"] = 0] = "NONE";
    FirmwareUpdateDeviceId[FirmwareUpdateDeviceId["solarxr_protocol_datatypes_DeviceIdTable"] = 1] = "solarxr_protocol_datatypes_DeviceIdTable";
    FirmwareUpdateDeviceId[FirmwareUpdateDeviceId["SerialDevicePort"] = 2] = "SerialDevicePort";
})(FirmwareUpdateDeviceId = exports.FirmwareUpdateDeviceId || (exports.FirmwareUpdateDeviceId = {}));
function unionToFirmwareUpdateDeviceId(type, accessor) {
    switch (FirmwareUpdateDeviceId[type]) {
        case 'NONE': return null;
        case 'solarxr_protocol_datatypes_DeviceIdTable': return accessor(new device_id_table_js_1.DeviceIdTable());
        case 'SerialDevicePort': return accessor(new serial_device_port_js_1.SerialDevicePort());
        default: return null;
    }
}
exports.unionToFirmwareUpdateDeviceId = unionToFirmwareUpdateDeviceId;
function unionListToFirmwareUpdateDeviceId(type, accessor, index) {
    switch (FirmwareUpdateDeviceId[type]) {
        case 'NONE': return null;
        case 'solarxr_protocol_datatypes_DeviceIdTable': return accessor(index, new device_id_table_js_1.DeviceIdTable());
        case 'SerialDevicePort': return accessor(index, new serial_device_port_js_1.SerialDevicePort());
        default: return null;
    }
}
exports.unionListToFirmwareUpdateDeviceId = unionListToFirmwareUpdateDeviceId;
